export default __webpack_public_path__ + "static/media/chk-white.3603d554.svg";